import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { SetDoControl } from 'src/app/project/shared/interfaces/set-do-control';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';

@Component({
  selector: 'avs-set-do-control',
  standalone: false,
  templateUrl: './set-do-control.component.html',
  styleUrl: './set-do-control.component.css'
})
export class SetDoControlComponent implements OnInit, OnChanges {

  @Input() selectedDoChannel?: DataEndChannel; /*  */


  public state: boolean = false; /* deChannel auslesen <-- */
  public stateChanged: boolean = false;
  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.parseChannelState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDoChannel'] && this.selectedDoChannel) {
      this.parseChannelState();
    }
  }

  private parseChannelState(): void {
    if (this.selectedDoChannel) {
      let doControl = this.selectedDoChannel.manualControl;
      if (doControl) {
        let parsedDoSettings = JSON.parse(doControl.settings);
        let parsedDo = parsedDoSettings.DO;
        this.state = parsedDoSettings.DO.State;
      } else {
        this.alertService.alert('No manual control found for this channel.', AlertTypes.info);
        return;
      }
    }
  }

  public createDoControl(): void {
    this.setDoManualControl();
  }

  public turnDoControlOff(): void {
    let doControl = {
      active: false,
      state: true

    } as SetDoControl;
    if (this.selectedDoChannel) {
      this.dataEndChannelService.setDoManualControl(Number(this.selectedDoChannel.id), doControl).subscribe(resp => {
        this.alertService.alert('DO Control wurde ausgeschaltet', AlertTypes.success);

      });
    } else {
      this.alertService.alert('Fehler beim setzen', AlertTypes.error);
    }
  }

  onStateChanged(): void {
    this.stateChanged = true;
  }

  public setDoManualControl(): void {
    let doControl = {
      active: true,
      state: this.state
    } as SetDoControl;

    if (this.selectedDoChannel) {
      this.dataEndChannelService.setDoManualControl(Number(this.selectedDoChannel.id), doControl).subscribe(resp => {

        this.alertService.alert('DO Control wurde erstellt', AlertTypes.success);
      });
    } else {
      this.alertService.alert('Fehler beim setzen', AlertTypes.error);
    }
  }
}